import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DeviationWorkflowActionBodyDto } from 'src/generated/services/TFinancialApi';
import { tFinancialService } from 'src/infra/services/tFinancialService';
import { invalidateShipmentCaches } from 'src/use-cases/invoice/useInvoices';

/**
 * Hook to confirm invoice
 * @returns Mutation function for confirming invoice
 */
export const useConfirmInvoice = (invoiceId: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (data: DeviationWorkflowActionBodyDto) => {
      const response = await tFinancialService.api.confirmInvoice(invoiceId, data);
      return response.data;
    },
    {
      onSuccess: () => {
        invalidateShipmentCaches(queryClient, invoiceId);
      },
    }
  );
};

/**
 * Hook to reject invoice
 * @returns Mutation function for rejecting invoice
 */
export const useRejectInvoice = (invoiceId: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (data: DeviationWorkflowActionBodyDto) => {
      const response = await tFinancialService.api.rejectInvoice(invoiceId, data);
      return response.data;
    },
    {
      onSuccess: () => {
        invalidateShipmentCaches(queryClient, invoiceId);
      },
    }
  );
};
